<template>
  <div class="banner__wrapper">
    <div class="container">
      <div class="banner__header">
        <div
          ref="logo"
          class="banner__header__logo wow fadeInLeft"
          data-wow-delay="0.75s"
        >
          <a href="#">
            <img src="../assets/images/logo_white.svg" alt />
          </a>
        </div>
        <div class="banner__header__menu">
          <span class="banner__header__menu__icon"></span>
          <ul>
            <li>
              <a class="scroll" href="#">主页</a>
            </li>
            <li>
              <a class="scroll" v-scroll-to="'#about-us'" href="#">关于我们</a>
            </li>
            <li>
              <a class="scroll" v-scroll-to="'#products'" href="#">产品介绍</a>
            </li>
            <li>
              <a class="scroll" v-scroll-to="'#report'" href="#">媒体报道</a>
            </li>
            <li>
              <a
                target="_blank"
                class="scroll"
                href="https://www.offerhk.com/newsdetail?id=1"
                >加入我们</a
              >
            </li>
          </ul>
        </div>
      </div>

      <div class="banner__text wow fadeInUp" data-wow-delay="1.25s">
        <h1>一站式。</h1>
        <h2>留学服务互联网生态圈</h2>
        <span style="line-height: 1.3">
          覆盖申请、生活、社交、就业、归国的留学服务“互联网+”平台，围绕海归人才打造一<br />
          个贯通整个留学产业链条的互联网生态体系
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import "animate.css";
import { WOW } from "wowjs";

export default {
  mounted() {
    this.$nextTick(() => {
      const wow = new WOW({
        live: false,
      });
      wow.init();
    });
  },
};
</script>

<style lang="scss" scoped>
.banner {
  &__wrapper {
    background: url(../assets/images/banner.png) no-repeat;
    min-height: 900px;
    background-size: cover;
    font-size: 14px;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    padding-top: 2.5em;

    &__logo {
      display: flex;
      align-items: center;
      justify-content: center;

      a {
        display: inline-block;
        transition: 0.5s all;
        img {
          width: 14.3em;
        }
      }
    }

    &__menu {
      ul li {
        display: inline-block;

        a {
          color: #fff;
          font-size: 1.1em;
          padding: 0 1em;
          text-decoration: none;
          display: block;
          font-weight: 400;

          &:hover {
            color: #0199e6;
          }
        }
      }
    }
  }

  &__text {
    width: 65%;
    margin-top: 10%;

    h1 {
      margin: 0;
      color: #fff;
      font-size: 5.125em;
      font-weight: 500;
      transition: 0.5s all;
      font-family: "Raleway", sans-serif;
    }

    h2 {
      margin: 0;
      font-size: 3.875em;
      color: #fff;
      font-weight: 300;
      margin-bottom: 2%;
    }

    span {
      color: white;
      font-size: 1em;
      line-height: 1em;
      display: inline-block;
    }
  }
}

@media (max-width: 1500px) {
  .banner {
    &__wrapper {
      min-height: 720px;
    }
  }
}

@media (max-width: 1250px) {
  .banner {
    &__wrapper {
      min-height: 620px;
    }
  }
}

@media (max-width: 1024px) {
  .banner {
    &__wrapper {
      min-height: 507px;
    }

    &__header {
      &__menu {
        ul li a {
          font-size: 1em;
        }
      }
    }

    &__text {
      width: 80%;
    }
  }
}

@media (max-width: 768px) {
  .banner {
    &__wrapper {
      min-height: 370px;
    }
    &__header {
      &__menu {
        ul li a {
          padding: 0 0.5em;
        }
      }
    }
    &__text {
      margin-top: 4%;
      h1 {
        font-size: 4.125em;
      }

      h2 {
        font-size: 2.875em;
      }

      span {
        font-size: 0.75em;
      }
    }
  }
}

@media (max-width: 640px) {
  .banner {
    &__wrapper {
      min-height: 330px;
    }

    &__header {
      padding-top: 1em;

      &__meun {
        &__icon {
          content: url(../assets/images/nav_icon.png);
          cursor: pointer;
          height: 32px;
        }
      }
    }

    &__text {
      h1 {
        font-size: 3.6em;
      }

      h2 {
        font-size: 2.5em;
      }
    }
  }
}

@media (max-width: 590px) {
  .banner {
    &__text {
      width: 100%;
      h1 {
        font-size: 3em;
      }
      h2 {
        font-size: 2em;
      }
    }
  }
}

@media (max-width: 480px) {
  .banner {
    &__wrapper {
      min-height: 210px;
    }
  }
}

@media (max-width: 320px) {
  .banner {
    &__wrapper {
      min-height: 210px;
    }
  }
}

.container {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  width: 1291px;
}
</style>
